import React, { useState, useEffect } from 'react'
import Slider from '@vtex/styleguide/lib/Slider'
import Price from '@/checkout-instore-legacy/components/Commons/Price'

import {
  FilterAttribute,
  isFilterRangeValue,
} from '@/checkout-instore-legacy/components/FilterSidebar/typings'
import { getCurrencySymbol } from '@/checkout-instore-legacy/utils/PaymentUtils'

type RangeProps = {
  attribute: FilterAttribute
  onChange: (key: string, value: any) => void
  type?: 'default' | 'price'
}

export const Range = ({
  attribute,
  onChange,
  type = 'default',
}: RangeProps) => {
  const initialDefaultValue = [attribute.minValue, attribute.maxValue]

  const [values, setValues] = useState(initialDefaultValue)

  const formatValue = (currentValue: number) => {
    switch (type) {
      case 'price':
        return (
          // TODO: this error popped up when moving the checkout-instore project
          // to checkout-instore-legacy, but needs to be fixed at some point
          // @ts-ignore
          <Price
            value={currentValue * 100}
            freePriceLabel={`${getCurrencySymbol()} 0`}
          />
        )
      case 'default':
        return currentValue
    }
  }

  useEffect(() => {
    const firstAttrValue = attribute.values[0]

    const attributeValues =
      firstAttrValue && isFilterRangeValue(firstAttrValue)
        ? [parseFloat(firstAttrValue.from), parseFloat(firstAttrValue.to)]
        : [attribute.minValue, attribute.maxValue]

    const currentValues =
      attribute.active && attribute.values.length === 1
        ? attributeValues
        : initialDefaultValue
    setValues(currentValues)
    // no need to pass initialDefaultValue here
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attribute])

  return (
    <div className="mt5 f6 pl3">
      <Slider
        onChange={([leftValue, rightValue]: [number, number]) => {
          onChange(attribute.key, {
            minValue: leftValue,
            maxValue: rightValue,
          })
        }}
        min={attribute.minValue}
        max={attribute.maxValue}
        step={1}
        disabled={false}
        defaultValues={values}
        alwaysShowCurrentValue={false}
        formatValue={formatValue}
        values={values}
        range
      />
    </div>
  )
}
